import type { RouteObject } from 'react-router';

import { RequireAuth } from '@/features/auth/guards';

import { AllSetPage } from './all-set-page';
import { BrandStepPage } from './brand-step-page';
import { CompetitorsStepPage } from './competitors-step-page';
import { OnboardingGate } from './guards';
import { OnboardingLayout } from './onboarding-layout';
import { PaymentPage } from './payment-page';
import { PlanStepPage } from './plan-step-page';
import { PlatformsStepPage } from './platforms-step-page';
import { SettingUpPage } from './setting-up-page';
import { SourcePage } from './source-page';
import { FINISH_PATHS, ONBOARDING_STEPS } from './steps';
import { TeamStepPage } from './team-step-page';
import { WorkspaceStepPage } from './workspace-step-page';

/**
 * Onboarding (Figma ↳ Onboarding Screens), signed-in only and outside the
 * app shell. The gate keeps people within their saved progress; the stepper
 * reads the step from the URL (see steps.ts). Step 1 creates the workspace;
 * later steps are UI only for now (their answers aren't stored yet).
 */
export const onboardingRoutes: RouteObject = {
  path: 'onboarding',
  element: (
    <RequireAuth>
      <OnboardingGate>
        <OnboardingLayout />
      </OnboardingGate>
    </RequireAuth>
  ),
  children: [
    { index: true, element: <WorkspaceStepPage /> },
    { path: ONBOARDING_STEPS[1].path, element: <BrandStepPage /> },
    { path: ONBOARDING_STEPS[2].path, element: <CompetitorsStepPage /> },
    { path: ONBOARDING_STEPS[3].path, element: <PlatformsStepPage /> },
    { path: ONBOARDING_STEPS[4].path, element: <PlanStepPage /> },
    { path: `${ONBOARDING_STEPS[4].path}/payment`, element: <PaymentPage /> },
    { path: ONBOARDING_STEPS[5].path, element: <TeamStepPage /> },
    { path: FINISH_PATHS.source, element: <SourcePage /> },
    { path: FINISH_PATHS.settingUp, element: <SettingUpPage /> },
    { path: FINISH_PATHS.done, element: <AllSetPage /> },
  ],
};
